import React from "react";
import "./PromoBanner.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const PromoBanner = () => {
  return (
    <section className="promo-banner-container my-5 border-radius-20">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="promo-banner"
        >
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="promo-heading"
          >
            Elevate Every Puff
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="promo-code-text"
          >
            Crafted for those who live bold and breathe free.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            <Link to="/category/67f040b28b7647368d057bdd">
              <button className="promo-shop-now-button">Explore Collection</button>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default PromoBanner;

